function hexToRgb(hex) {
  const c = hex.replace('#', '');
  return {
    r: parseInt(c.slice(0, 2), 16),
    g: parseInt(c.slice(2, 4), 16),
    b: parseInt(c.slice(4, 6), 16),
  };
}

function rgbToHex(r, g, b) {
  const clamp = v => Math.round(Math.max(0, Math.min(255, v)));
  return '#' + [r, g, b].map(v => clamp(v).toString(16).padStart(2, '0')).join('');
}

function mix(hex1, hex2, w) {
  const a = hexToRgb(hex1), b = hexToRgb(hex2);
  return rgbToHex(
    a.r + (b.r - a.r) * w,
    a.g + (b.g - a.g) * w,
    a.b + (b.b - a.b) * w,
  );
}

export function alpha(hex, a) {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r},${g},${b},${a})`;
}

const lighten = (hex, w) => mix(hex, '#ffffff', w);
const darken  = (hex, w) => mix(hex, '#000000', w);

export function buildPalette(primary, accent, base) {
  const textLight = lighten(base, 0.88);
  return {
    primary,
    accent,
    bg: {
      default:  base,
      paper:    mix(base, primary, 0.22),
      header:   mix(base, primary, 0.44),
      appBar:   mix(base, primary, 0.33),
      player:   darken(base, 0.18),
      elevated: mix(base, primary, 0.16),
    },
    text: {
      primary:   textLight,
      secondary: mix(textLight, lighten(primary, 0.4), 0.48),
    },
    border: {
      light:  alpha(primary, 0.28),
      medium: alpha(primary, 0.46),
      accent: alpha(accent,  0.28),
      appBar: alpha(accent,  0.38),
    },
    live: {
      bg:     'rgba(76,175,80,0.13)',
      color:  '#4caf50',
      border: 'rgba(76,175,80,0.32)',
    },
    upcoming: {
      bg:     alpha(accent, 0.13),
      color:  accent,
      border: alpha(accent, 0.32),
    },
    chip: {
      bg:    alpha(primary, 0.65),
      color: accent,
    },
    selected: {
      bg:    alpha(primary, 0.38),
      hover: alpha(primary, 0.2),
    },
    shadow: {
      card:   `0 2px 12px ${alpha(base, 0.7)}`,
      appBar: `0 4px 20px ${alpha(base, 0.8)}`,
    },
    gradient: {
      appBar: `linear-gradient(135deg, ${mix(base, primary, 0.55)} 0%, ${mix(base, primary, 0.22)} 100%)`,
      player: `linear-gradient(180deg, ${alpha(base, 0)} 60%, ${alpha(base, 0.6)} 100%)`,
    },
  };
}
